import modelmaticLogo from '@/assets/images/modelmatic_logo.png'
import { useTranslation } from '@/hooks/useTranslation'
import './ModelMaticLoader.css'

export function ModelMaticLoader() {
	const { t } = useTranslation()

	return (
		<div
			className="mm-loader-overlay"
			role="status"
			aria-live="polite"
			aria-label={t('common.loading')}
		>
			<div className="mm-loader-brand" aria-hidden="true">
				<img src={modelmaticLogo} alt="" className="mm-loader-logo" />
				<span className="mm-loader-wordmark">ModelMatic</span>
			</div>
			<div className="mm-loader-caption" aria-hidden="true">
				{t('common.loading')}
			</div>
		</div>
	)
}
